import { SharedModule } from './shared/modules/shared.module/shared.module';
import { NgPipesModule } from 'ngx-pipes';
import { CustomErrorHandler } from './custom-error-handler';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CoreModule } from './core.module/core.module';
import { AppComponent } from './app.component';
import 'hammerjs'; // causes webpack to load this
import 'hammer-timejs'; // causes webpack to load this
import { ErrorHandler } from '@angular/core';
import { ToastrModule, ToastContainerModule, ToastrService } from 'ngx-toastr';


export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any>{ // override default settings
    'swipe': {
      velocity: 0.4,
      threshold: 20,
      direction: Hammer.DIRECTION_ALL
    }

  };
}

// loopback
import { SDKBrowserModule } from './shared/sdk/index';
import { ClaimPageComponent } from './claim-page/claim-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    ClaimPageComponent
  ],
  imports: [
    SDKBrowserModule.forRoot(), // loopback sdk
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(),
    ToastrModule.forRoot(),
    ToastContainerModule,
    FormsModule,
    ReactiveFormsModule,
    NgPipesModule,
    SharedModule,
    AppRoutingModule // main routes defined in here
  ],
  providers: [{
    provide: HAMMER_GESTURE_CONFIG,
    useClass: MyHammerConfig,

  },
  { provide: ErrorHandler, useClass: CustomErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }






// WEBPACK FOOTER //
// ./src/app/app.module.ts